import { useMemo, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getJoinedCommunitiesAction } from "../redux/actions/communityActions";
import JoinedCommunityCard from "../components/community/JoinedCommunityCard";
import CommonLoading from "../components/loader/CommonLoading";
import ContentWithCards from "../components/shared/ContentWithCards";

const MyCommunities = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const joinedCommunities = useSelector(
    (state) => state.community?.joinedCommunities
  );

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getJoinedCommunitiesAction());
      setLoading(false);
    };
    fetchData();
  }, [dispatch]);

  const communityCards = useMemo(() => {
    if (!joinedCommunities) {
      return null;
    }
    return joinedCommunities.map((community) => (
      <JoinedCommunityCard key={community._id} community={community} />
    ));
  }, [joinedCommunities]);

  if (loading) {
    return (
      <ContentWithCards>
        <div className="col-span-2 flex h-screen items-center justify-center">
          <CommonLoading />
        </div>
      </ContentWithCards>
    );
  }

  return (
    <ContentWithCards>
      <div className="main-section bg-white border rounded-lg p-4 shadow-sm">
        <h2 className="text-lg font-semibold text-gray-700 mb-4 text-center border-b py-2 font-heading">
          Post in My Communities
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {communityCards}
        </div>
      </div>
    </ContentWithCards>
  );
};

export default MyCommunities;
